import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import BookingPage from './features/booking/BookingPage';
import LandingPage from './features/booking/LandingPage';

const theme = createTheme({
  palette: {
    primary: {
      main: '#3c3c3c',
      light: '#5a5a5a',
      dark: '#1f1f1f',
    },
    secondary: {
      main: '#707070',
      light: '#9a9a9a',
      dark: '#4a4a4a',
    },
    background: {
      default: '#f5f6f7',
      paper: '#ffffff',
    },
    text: {
      primary: '#0f0f0f',
      secondary: '#0f0f0f',
    },
    grey: {
      50: '#f9f9f9',
      100: '#f0f0f0',
      200: '#dedede',
      300: '#c9c9c9',
      400: '#b5b5b5',
      500: '#9e9e9e',
      600: '#878787',
      700: '#6f6f6f',
      800: '#585858',
      900: '#424242',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Inter", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 500,
      color: '#0f0f0f',
    },
    h2: {
      fontWeight: 500,
      color: '#0f0f0f',
    },
    h3: {
      fontWeight: 500,
      color: '#0f0f0f',
    },
    h4: {
      fontWeight: 500,
      color: '#0f0f0f',
    },
    h5: {
      fontWeight: 500,
      color: '#0f0f0f',
    },
    h6: {
      fontWeight: 500,
      color: '#0f0f0f',
    },
    body1: {
      color: '#0f0f0f',
    },
    body2: {
      color: '#4f4f4f',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 18,
          textTransform: 'none',
          fontWeight: 500,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
          },
        },
        contained: {
          backgroundColor: '#e6e6e6',
          color: '#0f0f0f',
          '&:hover': {
            backgroundColor: '#d4d4d4',
          },
        },
        outlined: {
          borderColor: '#c9c9c9',
          color: '#0f0f0f',
          '&:hover': {
            backgroundColor: '#f3f3f3',
            borderColor: '#b5b5b5',
          },
        },
        text: {
          color: '#0f0f0f',
          '&:hover': {
            backgroundColor: '#f3f3f3',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
          border: '1px solid #e4e4e4',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundColor: '#ffffff',
          color: '#0f0f0f',
        },
      },
    },
  },
  shape: {
    borderRadius: 8,
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* Landing page shows available appointment takers */}
          <Route path="/" element={<LandingPage />} />
          {/* Slug-based booking page for specific appointment taker */}
          <Route path="/:slug" element={<BookingPage />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
